import React from "react";
import { useNationalRates } from "../../hooks/useNationalRates";

const NationalRatesSection: React.FC = () => {
  const { data: ratesData, isLoading, error } = useNationalRates();

  const thirtyYearRate = ratesData?.rates.find((rate) =>
    rate.source.includes("MND's 30 Year Fixed")
  );
  const fifteenYearRate = ratesData?.rates.find((rate) =>
    rate.source.includes("MND's 15 Year Fixed")
  );

  if (isLoading) {
    return (
      <div className="max-w-md mx-auto mt-8 mb-12">
        <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-medium text-gray-900">
              National Average Mortgage Rates
            </h3>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="text-center p-3 bg-gray-50 rounded-lg animate-pulse">
              <div className="h-4 bg-gray-200 rounded w-24 mx-auto mb-2"></div>
              <div className="h-8 bg-gray-200 rounded w-16 mx-auto"></div>
            </div>
            <div className="text-center p-3 bg-gray-50 rounded-lg animate-pulse">
              <div className="h-4 bg-gray-200 rounded w-24 mx-auto mb-2"></div>
              <div className="h-8 bg-gray-200 rounded w-16 mx-auto"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // if error or both the 30 year and 15 year rates are not found, return null
  if (error || (!thirtyYearRate && !fifteenYearRate)) {
    return null;
  }

  return (
    <div className="max-w-md mx-auto mt-8 mb-4 sm:mb-6">
      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-gray-900">
            National Average Mortgage Rates
          </h3>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {thirtyYearRate && (
            <div className="text-center p-3 bg-gray-50 rounded-lg">
              <span className="text-sm text-gray-600 block mb-1">
                30-Year Fixed
              </span>
              <span className="text-2xl font-bold text-primary">
                {thirtyYearRate.rate}
              </span>
            </div>
          )}
          {fifteenYearRate && (
            <div className="text-center p-3 bg-gray-50 rounded-lg">
              <span className="text-sm text-gray-600 block mb-1">
                15-Year Fixed
              </span>
              <span className="text-2xl font-bold text-primary">
                {fifteenYearRate.rate}
              </span>
            </div>
          )}
        </div>
        {thirtyYearRate?.date && (
          <div className="mt-3 text-center">
            <span className="text-xs text-gray-500">
              Last updated: {new Date(thirtyYearRate.date).toLocaleDateString()}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default NationalRatesSection;
